import { BaseSopOperation } from "./_Base";
import { Color } from "three";
import { Vector3 } from "three";
import { CoreTransform } from "../../../core/Transform";
import { isBooleanTrue } from "../../../core/Type";
import { Water } from "../../../modules/core/objects/Water";
import { TransformResetMode, TransformResetSopOperation, TRANSFORM_RESET_MODES } from "./TransformReset";
const DEFAULT_PARAMS = {
  pixelRatio: 1,
  clipBias: 0,
  active: true,
  tblur: false,
  blur: 0,
  verticalBlurMult: 0,
  tblur2: false,
  blur2: 0,
  verticalBlur2Mult: 0
};
export class OceanPlaneSopOperation extends BaseSopOperation {
  constructor() {
    super(...arguments);
    this._coreTransform = new CoreTransform();
  }
  static type() {
    return "oceanPlane";
  }
  async cook(inputCoreGroups, params) {
    var _a;
    this._transformResetOptions = this._transformResetOptions || new TransformResetSopOperation(this._scene);
    const transformResetMode = TRANSFORM_RESET_MODES.indexOf(TransformResetMode.PROMOTE_GEO_TO_OBJECT);
    const inputCoreGroup = this._transformResetOptions.cook(inputCoreGroups, { mode: transformResetMode });
    const renderer = (_a = this._node) == null ? void 0 : _a.scene().renderersRegister.lastRegisteredRenderer();
    const objects = inputCoreGroup.objectsWithGeo();
    const waterObjects = [];
    const scene = this.scene().threejsScene();
    for (let object of objects) {
      Water.rotateGeometry(object.geometry, params.direction);
      const waterOptions = {
        polyScene: this.scene(),
        scene,
        renderer,
        ...DEFAULT_PARAMS,
        direction: params.direction,
        sunDirection: params.sunDirection,
        sunColor: params.sunColor,
        wavesHeight: params.wavesHeight,
        waterColor: params.waterColor,
        reflectionColor: params.reflectionColor,
        reflectionFresnel: params.reflectionFresnel,
        distortionScale: params.distortionScale,
        timeScale: params.timeScale,
        size: params.size,
        normalBias: params.normalBias,
        multisamples: params.multisamples,
        useFog: params.useFog
      };
      const water = new Water(object.geometry, waterOptions);
      waterObjects.push(water);
      water.matrixAutoUpdate = false;
      object.matrix.decompose(object.position, object.quaternion, object.scale);
      water.position.copy(object.position);
      water.rotation.copy(object.rotation);
      water.scale.copy(object.scale);
      water.updateMatrix();
      Water.compensateGeometryRotation(water, params.direction);
      const material = water.material;
      material.uniforms.direction.value.copy(params.direction);
      material.uniforms.sunDirection.value.copy(params.sunDirection);
      material.uniforms.sunColor.value.copy(params.sunColor);
      material.uniforms.wavesHeight.value = params.wavesHeight;
      material.uniforms.waterColor.value.copy(params.waterColor);
      material.uniforms.reflectionColor.value.copy(params.reflectionColor);
      material.uniforms.reflectionFresnel.value = params.reflectionFresnel;
      material.uniforms.distortionScale.value = params.distortionScale;
      material.uniforms.timeScale.value = params.timeScale;
      material.uniforms.size.value = params.size;
      material.uniforms.normalBias.value = params.normalBias;
      water.setReflectionActive(isBooleanTrue(params.renderReflection));
    }
    return this.createCoreGroupFromObjects(waterObjects);
  }
}
OceanPlaneSopOperation.DEFAULT_PARAMS = {
  direction: new Vector3(0, 1, 0),
  sunDirection: new Vector3(1, 1, 1),
  sunColor: new Color(1, 1, 1),
  wavesHeight: 1,
  waterColor: new Color(7695),
  reflectionColor: new Color(16777215),
  reflectionFresnel: 1,
  distortionScale: 1,
  timeScale: 1,
  size: 10,
  renderReflection: true,
  normalBias: 1e-3,
  multisamples: 1,
  useFog: false
};
